// extracted by mini-css-extract-plugin
module.exports = {"grow":"message_grow__1HFrs"};